import { AxiosResponse } from 'axios';
import BaseApi from './BaseApi';
import { KeyRecoveryStatus } from 'constants/key-recovery';
import {
  ICompanyVerificationInfo,
  CompanyDocumentType,
} from 'constants/company-verification';
import { ISignerInfo, SignerPermissons } from 'constants/signers';

const OperatorAPI = {
  getRecoveries(
    token: string,
    status?: KeyRecoveryStatus
  ): Promise<AxiosResponse> {
    return BaseApi.get('/api/operator/recoveries', {
      params: {
        status,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getRecovery(token: string, id: number): Promise<AxiosResponse> {
    return BaseApi.get(`/api/operator/recoveries/${id}`, {
      params: {
        id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  approveRecovery(
    token: string,
    payload: { recoveryId: number; privateKey: string }
  ): Promise<AxiosResponse> {
    return BaseApi.post(
      `/api/operator/recoveries/${payload.recoveryId}/approve`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getVerifications(token: string, verified?: boolean): Promise<AxiosResponse> {
    return BaseApi.get('/api/operator/verifications', {
      params: {
        verified,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getVerification(
    token: string,
    orgId: number
  ): Promise<AxiosResponse<ICompanyVerificationInfo>> {
    return BaseApi.get(`/api/operator/verifications/${orgId}`, {
      params: {
        orgId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  approveVerification(
    token: string,
    payload: { orgId: number }
  ): Promise<AxiosResponse> {
    return BaseApi.post('/api/operator/verifications/approve', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getVerificationDocument(
    token: string,
    id: number,
    type: CompanyDocumentType
  ): Promise<AxiosResponse> {
    return BaseApi.get(`/api/operator/verifications/${id}/document`, {
      params: {
        id,
        type,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'arraybuffer',
    });
  },
  getSigners(token: string): Promise<AxiosResponse<ISignerInfo[]>> {
    return BaseApi.get('/api/operator/signers', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  grantPermissionToSigner(
    token: string,
    payload: {
      userId: number;
      permissionType: SignerPermissons;
      expiryDate: string;
      privateKey: string;
    }
  ) {
    return BaseApi.post('/api/operator/signers/grant/permission', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getSigner(token: string, id: number): Promise<AxiosResponse<ISignerInfo>> {
    return BaseApi.get(`/api/operator/signers/${id}`, {
      params: {
        id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  signPermission(
    token: string,
    payload: {
      userId: number;
      permissionType: SignerPermissons;
      privateKey: string;
    }
  ) {
    return BaseApi.post('/api/operator/signers/permission/sign', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default OperatorAPI;
